
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impact-token-marketplace",
      function () {
        return require("private-next-pages/impact-token-marketplace/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/impact-token-marketplace"])
      });
    }
  